import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/privacidad" element={<PrivacyPage data-id="element-5" />} data-id="element-4" />
        <Route path="/terminos" element={<TermsPage data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}